export { ScrollableTabs } from './ScrollableTabs';
